<template>
    <div>
        <v-toolbar style="background-color: white !important;" flat>
            <v-toolbar-title>{{ $t('LeftSide.header.setting') }}</v-toolbar-title>
        </v-toolbar>
        <v-list dense class="pt-0" v-for="(item, index) in list_menu" :key="index">
            <v-subheader class="sub-header">{{ item.title }}</v-subheader>
            <v-list-item-group v-model="item.model" color="primary">
                <template v-for="(menu, i) in item.list">
                    <v-list-item @click="changepathservice(menu.path, menu.type)"
                        v-if="menu.status === undefined || menu.status === 'true'">
                        <v-list-item-icon>
                            <v-icon v-if="menu.icon !== ''" v-text="menu.icon" class="fz-18"></v-icon>
                            <img v-else :src="menu.img" alt="" width="30px" height="30px">
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title v-text="menu.text"></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider v-if="i < item.list.length - 1 && item.divider !== null" :key="i"></v-divider>
                </template>
            </v-list-item-group>
        </v-list>
        <MenuLayout />
        <CheckBrowserDialog :checkBrowserDialog="checkBrowserDialog" @closeCheckBrowser="closeCheckBrowser"
            :checkBrowserInfor="checkBrowserInfor"></CheckBrowserDialog>
    </div>
</template>
<script>
import { Momenttime, Encode } from '@/services';
import MenuLayout from '@/views/MenuLayout'
import CheckBrowserDialog from '@/components/dialog/CheckBrowserDialog.vue';

export default {
    data: () => ({
        publicPath: process.env.VUE_APP_BASE_PATH,
        selectedItem: null,
        selectedItemGeneral: null,
        list_setting: [],
        list_general: [],
        list_service: [],
        list_menu: [],
        login_page: "",
        data_user: {},
        checkBrowserDialog: false,
        checkBrowserInfor: {},
    }),
    components: {
        MenuLayout,
        CheckBrowserDialog,
    },
    watch: {
        '$i18n.locale'() {
            this.list_setting = [
                { text: this.$t('HeaderMenubar.editProfile'), icon: 'fa-solid fa-user', path: '/profile', type: 'route' },
                { text: this.$t('HeaderMenubar.managefriend'), icon: 'fa-solid fa-user-group', path: '/friend', type: 'route' },
                { text: this.$t('HeaderMenubar.loa'), icon: 'fa-solid fa-user-shield', path: 'loa', type: 'route' },
            ]
            // this.list_general = [
            //     { text: this.$t('HeaderMenubar.languages'), icon: 'fa-solid fa-globe', path: '/languages' },
            //     { text: this.$t('HeaderMenubar.logout'), icon: 'fa-solid fa-right-from-bracket', path: 'logout', status: this.login_page },
            // ]
            this.list_general = [
                { text: this.$t('HeaderMenubar.languages'), icon: 'fa-solid fa-globe', path: '/languages', type: 'route' },
                {
                    text: this.$t('HeaderMenubar.feedback'),
                    icon: 'fa-solid fa-comments',
                    path: '/feedback',
                    type: 'route'
                },
                {
                    text: this.$t('HeaderMenubar.support'),
                    icon: 'fa-solid fa-circle-question',
                    path: '/support',
                    type: 'route'
                },
                {
                    text: this.$t('HeaderMenubar.policy'),
                    icon: 'fa-solid fa-address-book',
                    path: '/policy',
                    type: 'route'
                },
                {
                    text: this.$t('HeaderMenubar.terms_of_service'),
                    icon: 'fa-solid fa-clipboard-question',
                    path: '/termsofservice',
                    type: 'route'
                },
                // { text: this.$t('HeaderMenubar.logout'), icon: 'fa-solid fa-right-from-bracket', path: 'logout', status: this.login_page },

            ]
            this.list_service = [
                {
                    text: 'OneEmail',
                    icon: '',
                    img: `${this.publicPath}/assets/img/oneplatform/oneemail2.png`,
                    path: process.env.VUE_APP_WEB_ONEEMAIL,
                    type: 'link'
                },
                {
                    text: 'OneBox',
                    icon: '',
                    img: `${this.publicPath}/assets/img/oneplatform/onebox.png`,
                    path: process.env.VUE_APP_WEB_ONEBOX,
                    type: 'share_token_onebox'
                },
                // {
                //     text: 'OneChat News',
                //     icon: '',
                //     img: `${this.publicPath}/assets/img/oneplatform/onechat_news.jpg`,
                //     path: process.env.VUE_APP_WEB_NEWS,
                //     type: 'function_news'
                // },
                {
                    text: 'One Anonymous',
                    icon: '',
                    img: `${this.publicPath}/assets/img/oneplatform/anonymousone.png`,
                    path: '/anonymousone',
                    type: 'route'
                },
                // {
                //   title: 'ส่งไฟล์ไป One box',
                //   icon: 'file_upload',
                //   path: '/mobile/settings/uploadfile/onebox',
                //   type: 'route'
                // }
            ]
            // this.list_service = [
            //     { text: this.$t('HeaderMenubar.languages'), icon: 'fa-solid fa-globe', path: '/languages' },
            //     { text: this.$t('HeaderMenubar.logout'), icon: 'fa-solid fa-right-from-bracket', path: 'logout', status: this.login_page },
            // ]
            this.list_menu = [
                { list: this.list_setting, title: this.$t('HeaderMenubar.profile'), model: this.selectedItem, divider: true },
                { list: this.list_service, title: this.$t('LeftSide.header.service'), model: this.selectedItem, divider: true },
                { list: this.list_general, title: this.$t('HeaderMenubar.general'), model: this.selectedItemGeneral, divider: true }
            ]
        }
    },
    created() {
        this.login_page = this.$cookie.get('login-page')
        // console.log("this.login_page => ", this.login_page);
        this.list_setting = [
            { text: this.$t('HeaderMenubar.editProfile'), icon: 'fa-solid fa-user', path: '/profile', type: 'route' },
            { text: this.$t('HeaderMenubar.managefriend'), icon: 'fa-solid fa-user-group', path: '/friend', type: 'route' },
            { text: this.$t('HeaderMenubar.loa'), icon: 'fa-solid fa-user-shield', path: 'loa', type: 'route' },
        ]
        // this.list_general = [
        //     { text: this.$t('HeaderMenubar.languages'), icon: 'fa-solid fa-globe', path: '/languages' },
        //     { text: this.$t('HeaderMenubar.logout'), icon: 'fa-solid fa-right-from-bracket', path: 'logout', status: this.login_page },
        // ]
        this.list_general = [
                { text: this.$t('HeaderMenubar.languages'), icon: 'fa-solid fa-globe', path: '/languages', type: 'route' },
                {
                    text: this.$t('HeaderMenubar.feedback'),
                    icon: 'fa-solid fa-comments',
                    path: '/feedback',
                    type: 'route'
                },
                {
                    text: this.$t('HeaderMenubar.support'),
                    icon: 'fa-solid fa-circle-question',
                    path: '/support',
                    type: 'route'
                },
                {
                    text: this.$t('HeaderMenubar.policy'),
                    icon: 'fa-solid fa-address-book',
                    path: '/policy',
                    type: 'route'
                },
                {
                    text: this.$t('HeaderMenubar.terms_of_service'),
                    icon: 'fa-solid fa-clipboard-question',
                    path: '/termsofservice',
                    type: 'route'
                },
                // { text: this.$t('HeaderMenubar.logout'), icon: 'fa-solid fa-right-from-bracket', path: 'logout', status: this.login_page },

            ]
        this.list_service = [
            {
                text: 'OneEmail',
                icon: '',
                img: `${this.publicPath}/assets/img/oneplatform/oneemail2.png`,
                path: process.env.VUE_APP_WEB_ONEEMAIL,
                type: 'link'
            },
            {
                text: 'OneBox',
                icon: '',
                img: `${this.publicPath}/assets/img/oneplatform/onebox.png`,
                path: process.env.VUE_APP_WEB_ONEBOX,
                type: 'share_token_onebox'
            },
            // {
            //     text: 'OneChat News',
            //     icon: '',
            //     img: `${this.publicPath}/assets/img/oneplatform/onechat_news.jpg`,
            //     path: process.env.VUE_APP_WEB_NEWS,
            //     type: 'function_news'
            // },
            {
                text: 'One Anonymous',
                icon: '',
                img: `${this.publicPath}/assets/img/oneplatform/anonymousone.png`,
                path: '/anonymousone',
                type: 'route'
            },
            // {
            //   title: 'ส่งไฟล์ไป One box',
            //   icon: 'file_upload',
            //   path: '/mobile/settings/uploadfile/onebox',
            //   type: 'route'
            // }
        ]
        this.list_menu = [
            { list: this.list_setting, title: this.$t('HeaderMenubar.profile'), model: this.selectedItem, divider: true },
            { list: this.list_service, title: this.$t('LeftSide.header.service'), model: this.selectedItem, divider: true },
            { list: this.list_general, title: this.$t('HeaderMenubar.general'), model: this.selectedItemGeneral, divider: true }
        ]
        var user_profile = ''
        if (JSON.parse(this.$cookie.get('user-profile') == null)) {
            user_profile = JSON.parse(localStorage.getItem('user-profile'))
        } else {
            user_profile = JSON.parse(this.$cookie.get('user-profile'))
        }
        this.data_user = user_profile['account']['profile']
    },
    methods: {
        closeCheckBrowser(value) {
            this.checkBrowserDialog = value
            this.checkBrowserInfor = {}
        },
        changepathservice(path, type) {
            // console.log('type' + type)
            if (type == 'link') {
                // window.open(path)
                this.checkBrowser(path)
            } else if (type == 'route') {
                this.toPage(path)
            } else if (type == 'function_news') {
                // console.log('test')
                // console.log(Momenttime.dayjsCreateDate())
                var test = {
                    one_id: this.data_user.one_id,
                    createdDate: Momenttime.dayjsCreateDate()
                }
                // window.open(path + Encode.encodeAuthen_news(test))
                this.checkBrowser(path + Encode.encodeAuthen_news(test))
            } else if (type === 'share_token_onebox') {
                this.axios.post(process.env.VUE_APP_API_message + `/api/v1/get_encode_shared_token`, {
                    user_id: this.data_user.one_id
                }).then((response) => {
                    // console.log(response.data.data.encode_shared_token)
                    var url = process.env.VUE_APP_REDIRECT_ONEBOX + response.data.data.encode_shared_token
                    this.checkBrowser(url)
                })
            }
        },
        checkBrowser(url) {
            // console.log(url)
            // console.log('check browser')
            // Get the user-agent string
            let userAgentString = navigator.userAgent;
            // Detect Chrome
            let chromeAgent = userAgentString.indexOf("Chrome") > -1;
            // Detect Internet Explorer
            let IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
            // Detect Firefox
            let firefoxAgent = userAgentString.indexOf("Firefox") > -1;
            // Detect Safari
            let safariAgent = userAgentString.indexOf("Safari") > -1;
            // Discard Safari since it also matches Chrome
            let operaAgent = userAgentString.indexOf("OP") > -1;
            // console.log('firefox = > ' + firefoxAgent)
            // console.log('ie = > ' + IExplorerAgent)
            // console.log('chrome = > ' + chromeAgent)
            // console.log('opera = > ' + operaAgent)
            // console.log('safari = > ' + safariAgent)
            if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
                this.checkBrowserInfor = {
                    url: url,
                    payload: ''
                }
                this.checkBrowserDialog = true
            } else if (safariAgent === true && chromeAgent === true) {
                window.open(url, '_blank')
            } else if (safariAgent === true) {
                this.checkBrowserInfor = {
                    url: url,
                    payload: ''
                }
                this.checkBrowserDialog = true
            } else {
                window.open(url, '_blank')
            }
        },
        toPage(path) {
            // console.log("path => ", path);
            // var me = this;
            this.$router.push(path)
            if (path === 'logout') {
                this.$cookie.delete('login-page')
                this.$cookie.delete('one_token')
                path = `${process.env.VUE_APP_URL_PRIVATE}/login?business_id=${this.data_user.one_id}&status_login=false`
                window.open(path, '_self')
            } else if (path === 'loa') {
                var url = process.env.VUE_APP_API_LOA
                var body = {
                    "tokenuser": this.data_user.tokenuser,
                    "url": url
                }
                this.axios.post(process.env.VUE_APP_API_NEW_GET_ACCESS_TOKEN, body).then((response) => {
                    window.open(url + response.data.data.accesstoken, '_blank')
                })
                this.$router.push('/setting')
            } else {
                this.$router
                    .push(path)
                    .catch((error) => {
                        if (error.name != "NavigationDuplicated") {
                            throw error;
                        }
                    });
            }
        },
    },
}
</script>
<style lang="css" scoped>
.fz-18 {
    font-size: 18px !important;
}

.sub-header {
    background-color: rgb(239, 239, 239) !important;
    color: black !important;
    font-size: 14px !important;
}
</style>